import { SnackbarTypes } from './index.model'

export const resetSnackbar = () => ({
  type: SnackbarTypes.SNACKBAR_RESET,
})

export const success = (data: any) => ({
  type: SnackbarTypes.SNACKBAR_SUCCESS,
  data,
})

export const error = (data: any) => ({
  type: SnackbarTypes.SNACKBAR_FAIL,
  data,
})

export const info = (data: any) => ({
  type: SnackbarTypes.SNACKBAR_INFO,
  data,
})
